<template>
    <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in items" :key="item.name">
            <v-form 
                :ref="item.name"
                v-model="isFormValid"
                class="patient-form-wrapper"
                :disabled="item.disabled" 
            >
                <b-alert
                    v-if="preview && !hasChangeRequest"
                    type="info"
                    message="Currently viewing patient data in preview mode."
                    :has-header-button="can('api.v1.patients.update')"
                    button-title="Edit patient"
                    :dismissible="false"
                    @emitAction="$root.goTo($root.route('patients.get', { id: id }))"
                >
                </b-alert>
                <component :is="item.name" v-bind="item.props" :preview="preview"></component>
                <patient-form-actions
                    v-if="item.hasActions && !preview"
                    :show-additional-buttons="item.additionalButtons"
                    :save-btn-disabled="disabledSaveBtn"
                    :is-valid="isFormValid"
                    @disable-save-btn="disabledSaveBtn = true"
                    @save="savePatient(item.name)"
                    @submit="savePatient(item.name)"
                ></patient-form-actions>
            </v-form>
        </v-tab-item>
    </v-tabs-items>
</template>

<script>
import BAlert from '../../../../../../bgo/bgo-components/resources/js/components/BAlert.vue';

export default {
    components: { BAlert },
    props: {
        preview: {
            type: Boolean,
            default: false,
        },
        hasChangeRequest: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            isFormValid: false,
            items: [
                { name: 'patient-form-details', hasActions: true, additionalButtons: true, disabled: this.preview },
                { name: 'patient-form-health-information', hasActions: true, disabled: this.preview },
                { name: 'patient-form-diagnosis', hasActions: true, disabled: this.preview },
                {
                    name: 'patient-dispensing-stage',
                    hasActions: false,
                    //BSS-482 - Dispensing stage should be enabled regardless preview mode
                    // disabled: this.preview,
                    // props: { disabled: this.preview },
                    disabled: false,
                    props: { disabled: false },
                },
                { name: 'blood-results-data-table', hasActions: false, disabled: false },
                { name: 'memos-data-table', hasActions: false, disabled: false },
                { name: 'patient-form-adverse-event', hasActions: false, disabled: false },
            ],
            disabledSaveBtn: false,
        };
    },
    computed: {
        tab: {
            get() {
                return this.$store.state.patients.tab;
            },
            set(value) {
                if (this.tab === 4 && value !== this.tab) {
                    this.$store.dispatch('patients/loadBloodResult', { id: null });
                }
                this.$store.dispatch('patients/changeTab', value);
            },
        },
    },
    created() {},
    methods: {
        savePatient(name) {
            if (this.$refs[name][0].validate()) {
                this.isFormValid = true;
            }
        },
    },
};
</script>
